import { ChangeEvent, useCallback, useEffect, useState } from "react";

import { ReactComponent as ArrowIcon } from "assets/svgs/Arrow.svg";
import BaseDropDownMenuProps, { DropdownOptionObject } from "./BaseDropDownMenuProps";

export type SimpleDropDownMenuProps = BaseDropDownMenuProps<DropdownOptionObject>;

const SimpleDropDownMenu = ({
    className = "",
    value = "",
    dropDownOptions = [],
    displayReverse = false,
    onSelect = (dropDownOption) => console.log(dropDownOption),
}: SimpleDropDownMenuProps) => {
    useEffect(() => {
        console.warn("displayReverse has no effect on SimpleDropDownMenu");
    }, [displayReverse]);
    const onChange = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            e.preventDefault();
            onSelect(
                dropDownOptions.find((o) => o.value === e.target.value) || { name: "", value: "" }
            );
        },
        [onSelect, dropDownOptions]
    );

    return (
        <select onChange={onChange} className={`bg-black90 px-2 ${className}`}>
            <option value="" selected={value === ""}></option>
            {dropDownOptions.map((o) => (
                <option selected={value === o.value} value={o.value}>
                    {o.name}
                </option>
            ))}
        </select>
    );
};

export default SimpleDropDownMenu;
